import { IndexApiSet, useIndexApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { SampleStatusLog, SampleStatusLogSearchForm } from 'entities/sample_status_log'

type SampleStatusLogsResponse = PagingResponse & {
    results: SampleStatusLog[]
}

export function useFetchSampleStatusLogsApi(searchForm: Form<SampleStatusLogSearchForm>): IndexApiSet<SampleStatusLogsResponse> & { execute: () => void } {
    const apiPath = 'sample_status_logs/'
    const api = useIndexApi<SampleStatusLogsResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
        initialState: { page: searchForm.object.page || 1, perPage: searchForm.object.perPage || 50 },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm.object })
    }

    useEffectSkipFirst(() => {
        searchForm.update((f) => {
            if (api.pageSet.page) f.page = api.pageSet.page
            if (api.pageSet.perPage) f.perPage = api.pageSet.perPage
        })
    }, [api.pageSet.page, api.pageSet.perPage])

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm.object])

    return { ...api, execute: execute }
}

